Vue.config.productionTip = false;
import Vue from 'vue';
import App from './App';
import router from './router';
import './assets/main.styl';
import {
    Vuetify,
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VToolbar,
    VCard,
    VDialog,
    VIcon,
    VParallax,
    VForm,
    VTextField,
    VTabs,
    VSubheader,
    VDivider,
    transitions,
    VSnackbar,
    VGrid,
    VAvatar,
    VProgressCircular,
    VTextarea
} from 'vuetify';
import scroll from '../node_modules/vuetify/es5/directives/scroll.js';
Vue.use(Vuetify, {
    directives: {
        scroll
    },
    components: {
        VApp,
        VNavigationDrawer,
        VFooter,
        VList,
        VBtn,
        VCard,
        VDialog,
        VIcon,
        VParallax,
        VForm,
        VTextField,
        VTabs,
        VSubheader,
        VDivider,
        transitions,
        VSnackbar,
        VGrid,
        VAvatar,
        VProgressCircular,
        VToolbar,
        VTextarea
    }
});
/* eslint-disable no-new */
import Vuex from 'vuex';
Vue.use(Vuex);
var store = new Vuex.Store({
    state: {
        blogPosts: [],
        signedIn: false
    },
    mutations: {
        addPost(state, post) {
            state.blogPosts.push(post);
            return state.blogPosts.indexOf(post);
        },
        addComment(state, d) {
            state.blogPosts[d.target].comments.push(d.comment);
        },
        signIn(state) {
            state.signedIn = true;
        },
        signOut(state) {
            state.signedIn = false;
        }
    }
});
var root = new Vue({
    router,
    store,
    render: h => h(App)
});
document.addEventListener('DOMContentLoaded', function() {
    root.$mount('#app');
});
import './material.css';
import firebase from './firebase.js';
// var firebase = Firebase.firebase;
var db = firebase.firestore();
db.settings({ timestampsInSnapshots: true });
db.collection('blogPosts')
    .orderBy('timestamp', 'desc')
    .get()
    .then(querySnapshot => {
        querySnapshot.forEach(doc => {
            let data = doc.data();
            data.comments = [];
            data.ref = doc.ref;
            data.date = data.timestamp.toDate().toDateString();
            data.id = doc.id;
            store.commit('addPost', data);
            db.collection('comments')
                .where('post', '==', doc.ref)
                .where('approved', '==', true)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        var comment = doc.data();
                        var d = {};
                        let index = store.state.blogPosts.indexOf(data);
                        d.target = index;
                        d.comment = comment;
                        store.commit('addComment', d);
                    });
                })
                .then(function() {});
            setTimeout(
                () => document.dispatchEvent(new Event('posts-loaded')),
                3000
            );
        });
    });



// WEBPACK FOOTER //
// ./src/main.js